export class EdgeComparerBySource {
    constructor(X) {
        this.x = X;
    }
    Compare(a, b) {
        const r = this.x[a.Source] - this.x[b.Source];
        if (r !== 0)
            return r;
        return this.x[a.Target] - this.x[b.Target];
    }
}
//# sourceMappingURL=edgeComparerBySource.js.map